import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GetQCApprovalDetailsNetworkAction } from "../../../redux/actions/PayoutAction";
import {
  AdditionalFinanceApptHeader,
  financeHeaderValue,
} from "./AdditionalFinanceApptHeader";
import { FinanceQcBulkUpload } from "./FinanceQcBulkUpload";
import Modal from "react-modal";
import { getNetworkMenuId, getToken } from "../../../Utils/types";
import { FinanceAppointmentDetails } from "./FinanceAppointmentDetails";

import { API_URL_WITHOUT_USER } from "../../../Utils/API";
import { isLoadingAction } from "../../../Utils/helper";

export const FinanceAppointment = ({
  rowData,
  searchFilter,
  setSearchFilter,
  payableData,
  setPayabelData,
  header,
  showData,
  setShowData,
}) => {
  const dispatch = useDispatch();
  const payoutReducer = useSelector((state) => state?.PayoutReducer);
  const [tableIndex, setTableIndex] = useState(null);
  const [bulkUploadOpen, setBulkUploadOpen] = useState(false);
  const [isEdit, setIsEdit] = useState({ data: null, open: false });
  console.log(getNetworkMenuId()?.canEdit === false);

  useEffect(() => {
    dispatch(
      GetQCApprovalDetailsNetworkAction({
        ...searchFilter,
        sessionId: rowData?.sessionId,
        ticketId: rowData?.requestID,
        providerId: rowData?.providerId,
      })
    );
  }, []);
  const downloadFile = (ele) => {
    isLoadingAction(true, dispatch);
    const url = `${API_URL_WITHOUT_USER}/NetworkVerification/ExportToExcelFinanceQCApprovalDetailsNetwork`;
    const data = {
      ...searchFilter,
      isExportToExcel: true,
      // providerIds: "",
    };
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: getToken(),
        MenuId: getNetworkMenuId()?.menuId,
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.blob())
      .then((blob) => {
        isLoadingAction(false, dispatch);
        const filename = "FinanceApprovalDetail.xlsx";
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((error) => {
        console.error("Failed to fetch the file");
      });
  };

  return (
    <>
      <div className=" d-flex justify-content-end p-2 gap-2">
        {getNetworkMenuId()?.canEdit === true && (
          <button
            className="setting_config ascDescBtn p-2"
            data-bs-toggle="modal"
            type="button"
            onClick={() => downloadFile()}
          >
            &nbsp; Export To Excel
          </button>
        )}
        {getNetworkMenuId()?.canEdit === true && (
          <button
            className="setting_config ascDescBtn p-2"
            data-bs-toggle="modal"
            type="button"
            onClick={() => setBulkUploadOpen(true)}
          >
            &nbsp; Bulk Upload
          </button>
        )}

        <button
          className="setting_config ascDescBtn p-2"
          data-bs-toggle="modal"
          data-bs-target="#additionalFilterApptHeader"
          type="button"
        >
          &nbsp;
          <i class="fa-solid fa-gear"></i>
        </button>
      </div>
      <div className="table-responsive __custom__properties pt-2">
        <table className="table">
          <thead>
            <tr className="avanishtbl">
              <th>
                <input
                  type="checkbox"
                  className="form-check-input"
                  readOnly
                  checked={
                    payoutReducer?.getQcApprovalAppt?.length ===
                    payableData?.length
                  }
                  onChange={(e) => {
                    if (e.target.checked) {
                      setPayabelData(payoutReducer?.getQcApprovalAppt);
                    } else {
                      setPayabelData([]);
                    }
                  }}
                />
              </th>
              <th style={{ minWidth: "220px" }}>Provider ID/Name</th>
              <th style={{ minWidth: "220px" }}>Client Name</th>
              <th style={{ textAlign: "center" }}>Case No</th>
              <th className="addHeader">Net Amount</th>
              {header?.map((ele) => (
                <th
                  className={`${
                    ele === "Additional Test" || ele === "Tests"
                      ? "financeAdditionalTest"
                      : "addHeader"
                  }`}
                >
                  {ele}
                </th>
              ))}
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {payoutReducer?.getQcApprovalAppt?.map((ele, itemIndex) => {
              return (
                <>
                  <tr key={ele?.clientId}>
                    <td>
                      <input
                        type="checkbox"
                        className="form-check-input"
                        checked={payableData?.some((item) => item === ele)}
                        // disabled={
                        //   ele?.requestStatus !== "Pending At Finance" &&
                        //   ele?.requestStatus !== "Partial QC" &&
                        //   ele?.requestStatus !== "Partial Finance"
                        // }
                        // checked = {}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setPayabelData([...payableData, ele]);
                          } else {
                            let arr = payableData.filter(
                              (item) => item !== ele
                            );
                            setPayabelData(arr);
                          }
                        }}
                        readOnly
                      />
                    </td>
                    <td>{ele?.providerName}</td>
                    <td>{ele?.insurereName}</td>
                    <td>{ele?.caseNo}</td>
                    <td style={{ textAlign: "center" }}>{ele?.netAmount}</td>
                    {header?.map((data) => {
                      return (
                        <td
                          className={`${
                            data === "Test Details"
                              ? "financeAdditionalTest"
                              : "addHeader"
                          }`}
                        >
                          {data === "Test Details" ? (
                            <>
                              {showData === true && tableIndex === itemIndex
                                ? ele[financeHeaderValue[data]]
                                : ele[financeHeaderValue[data]]
                                    .split(" ")
                                    ?.slice(0, 10)
                                    ?.join(" ")}
                              <a
                                id="payOutShowMoreBtn"
                                onClick={() => {
                                  if (data === "Test Details") {
                                    // setShowData(!showData);
                                    setTableIndex(itemIndex);
                                    setShowData(
                                      showData && tableIndex === itemIndex
                                        ? false
                                        : true
                                    );
                                  }
                                }}
                              >
                                {ele[financeHeaderValue[data]].split(" ")
                                  .length < 20
                                  ? ""
                                  : showData === true &&
                                    tableIndex === itemIndex
                                  ? " view less"
                                  : "...view more"}
                              </a>
                            </>
                          ) : (
                            ele[financeHeaderValue[data]]
                          )}
                        </td>
                      );
                    })}
                    <td className="width-80">
                      <p
                        className={`status-style ${
                          ele?.requestStatus === "Paid"
                            ? "approved"
                            : ele?.requestStatus === "Reject By Finance" ||
                              ele?.requestStatus === "Not Paid "
                            ? "rejected"
                            : ele?.requestStatus === "Pending At Finance" ||
                              ele?.requestStatus === "Pending at Network"
                            ? "pendingAtFinance"
                            : ele?.requestStatus === "Pending For Payment"
                            ? "pendingForpayment"
                            : ele?.requestStatus === "Partial Paid"
                            ? "partialPaid"
                            : ele?.requestStatus === "Pending For Provider"
                            ? "refundStatus"
                            : ele?.requestStatus === "Rejected By Provider"
                            ? "rejected"
                            : "pending"
                        }`}
                      >
                        {ele?.requestStatus}
                      </p>
                    </td>
                    {ele?.requestStatus === "Pending At Finance" && (
                      <td
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          if (getNetworkMenuId()?.canEdit === true) {
                            setIsEdit({ data: ele, open: true });
                          }
                        }}
                      >
                        <img src="./images/edit-icon.png" alt="" />
                      </td>
                    )}
                  </tr>
                </>
              );
            })}
          </tbody>
        </table>
        <div
          class="modal fade"
          id="additinalFinanceAppHeader"
          tabindex="-1"
          role="dialog"
          aria-labelledby="exampleModalCenterTitle"
          aria-hidden="true"
        >
          <AdditionalFinanceApptHeader />
        </div>
        <Modal
          isOpen={bulkUploadOpen}
          className="modal-add-user-popup modal-upload-excel-popup"
          overlayClassName="overlay-history-popup network-z-index"
          ariaHideApp={false}
        >
          <FinanceQcBulkUpload
            bulkUploadOpen={bulkUploadOpen}
            // searchFilter={searchFilter}
            // apiParams={apiParams}
            setBulkUploadOpen={setBulkUploadOpen}
          />
        </Modal>
        <Modal
          isOpen={isEdit.open}
          className="modal-add-user-popup modal-upload-excel-popup"
          overlayClassName="overlay-history-popup network-z-index"
          ariaHideApp={false}
        >
          <FinanceAppointmentDetails
            setIsEdit={setIsEdit}
            isEdit={isEdit}
            searchFilter={searchFilter}
            setPayabelData={setPayabelData}
            // apiParams={apiParams}
            // setBulkUploadOpen={setBulkUploadOpen}
          />
        </Modal>
      </div>
    </>
  );
};
